import api from './api'

export const authApi = {
  login(data) {
    return api.post('/auth/session', { ...data }).then(response => response.data)
  },
  requestPasswordReset(email) {
    return api.post('/auth/passwords', { password: { email } }).then(response => response.data)
  },
  validateResetToken(userId, token) {
    return api.get(`/auth/passwords/${userId}/edit`, { token }).then(response => response.data)
  },
  resetPassword(userId, token, password, passwordConfirmation) {
    return api.put(`/auth/passwords/${userId}`, {
      token,
      password: { password, passwordConfirmation },
    }).then(response => response.data)
  },
}
